import React, { useState, useEffect } from "react";
import { json, useNavigate, useLocation } from "react-router-dom";

function Profile() {
  const navigate = useNavigate();
  let [token, setToken] = useState("");
  const [error, setError] = useState("");
  const [registerDate, setRegisterDate] = useState("");
  const [companyCode, setCompanyCode] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [picName, setPicName] = useState("");
  const [email, setEmail] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyPhone, setCompanyPhone] = useState("");
  const [companyMobilePhone, setCompanyMobilePhone] = useState("");
  const [accountStatus, setAccountStatus] = useState("");
  const resource = "profile";
  const [isExternal, setIsExternal] = useState(true);
  const [internalName, setInternalName] = useState("");
  const [internalEmail, setInternalEmail] = useState("");
  const [internalRole, setInternalRole] = useState("");

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);

    const checkSessionToken = async () => {
      try {
        const response = await fetch(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          setError(data.message || "Failed to fetch session token data");
          throw new Error(data.message || "Failed to fetch session token data");
        }

        // Parse response text as a boolean value
        const text = await response.text();
        const data = text === "true";

        if (data) {
        } else {
          window.alert("Session is invalid");
          navigate("/login");
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    checkSessionToken();
  }, []);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    getProfile(storedToken);
  }, []);

  const getProfile = async (storedToken) => {
    // setLoading(true);
    try {
      const response = await fetch(
        `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/profile?token=${storedToken}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        setError(data.message || "Failed to fetch session token data");
        throw new Error(data.message || "Failed to fetch session token data");
      }

      if (data.isExternal) {
        setIsExternal(true);
        const external = data.data[0];
        setRegisterDate(formatDate(external.register_date));
        setCompanyName(external.company_name);
        setCompanyCode(external.company_code);
        setPicName(external.pic_name);
        setEmail(external.email);
        setCompanyAddress(external.company_address);
        setCompanyPhone(external.company_phone);
        setCompanyMobilePhone(external.company_mobile_phone);
        setAccountStatus(external.xcp_account_status);
      } else {
        setIsExternal(false);
        const internal = data.data[0];
        setInternalName(internal.xcp_internal_name);
        setInternalEmail(internal.xcp_internal_email);
        setInternalRole(internal.xcp_role_name);
      }
    } catch (error) {
      console.error("Error get profile:", error.message);
      setError("Error get profile: " + error.message);
    }
  };

  const handleStatusChange = (event) => {
    setAccountStatus(event.target.value);
  };

  const formatDate = (datetime) => {
    const date = new Date(datetime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    setRegisterDate(registerDate);
  }, [registerDate]);

  const handleBackClick = () => {
    navigate("/order-list");
  };

  return (
    <div className="container-order-input">
      <h1>Cross Connect Profile</h1>
      <form>
        <div className="order-information-order-input">
          <div className="title-order-input">
            {error && <p className="error-message">{error}</p>}
          </div>
        </div>
        <div className="box-two-part">
          <div className="requestor-information">
            {isExternal ? (
              <>
                <div className="textbox-gray">
                  <label htmlFor="companyCode">Company Code</label>
                  <input type="text" placeholder={companyCode} disabled />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="registerDate">Register Date</label>
                  <input text="date" placeholder={registerDate} disabled />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="companyName">Company Name</label>
                  <input type="text" placeholder={companyName} disabled />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="picName">PIC Name</label>
                  <input type="text" placeholder={picName} disabled />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="contactEmail">Email</label>
                  <input type="email" placeholder={email} disabled />
                </div>
                <div className="textbox">
                  <label htmlFor="companyAddress">Company Address</label>
                  <textarea
                    placeholder={companyAddress}
                    style={{ backgroundColor: "lightgrey", color: "black" }}
                    disabled
                  ></textarea>
                </div>
                <div className="textbox-gray">
                  <label htmlFor="companyPhone">Company Phone</label>
                  <input
                    type="tel"
                    id="companyPhone"
                    name="companyPhone"
                    placeholder={companyPhone}
                    pattern="0\d{6,}"
                    disabled
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="companyMobilePhone">Company Mobile Phone</label>
                  <input
                    type="tel"
                    id="companyMobilePhone"
                    name="companyMobilePhone"
                    placeholder={companyMobilePhone}
                    pattern="08\d{8,}"
                    disabled
                  />
                </div>
                <div className="radio-button">
                  <label>Status</label>
                  <div className="radio-button-option">
                    <label>
                      <input
                        type="radio"
                        value="ACTIVE"
                        checked={accountStatus === "ACTIVE"}
                        disabled
                      />
                      Active
                    </label>
                  </div>
                  <div className="radio-button-option">
                    <label>
                      <input
                        type="radio"
                        value="INACTIVE"
                        checked={accountStatus === "INACTIVE"}
                        onChange={handleStatusChange}
                        disabled
                      />
                      Inactive
                    </label>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="textbox-gray">
                  <label htmlFor="Name">Name</label>
                  <input type="text" placeholder={internalName} disabled />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="contactEmail">Email</label>
                  <input type="email" placeholder={internalEmail} disabled />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="Name">Role</label>
                  <input type="text" placeholder={internalRole} disabled />
                </div>
              </>
            )}
          </div>
        </div>
        <input
          type="button"
          className="btn-submit-order-input"
          value="Back"
          onClick={handleBackClick}
        />
      </form>
    </div>
  );
}

export default Profile;
